import React, { useState ,useEffect } from 'react';
import axios from 'axios';
import { Input, Button, Modal, Select } from 'antd';
import { message } from 'antd';
import {  EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';


const JobSearch = () => {
const [jobs, setJobs] = useState([]);
 // Fetch jobs from backend when component mounts
 useEffect(() => {
   
    axios.get('http://localhost:8080/api/user/jobs/all')
      .then(response => {
        setJobs(response.data);
        setFilteredJobs(response.data);
      })
      .catch(error => {
        console.error('Error fetching jobs:', error);
      });
  }, []);

  console.log("jobs"+jobs);

const jobTitles = [...new Set(jobs.map(job => job.jobTitle))];
const skills = [...new Set(jobs.map(job => job.primarySkill))];
const locations = [...new Set(jobs.map(job => job.jobLocation))];
const emails = [...new Set(jobs.map(job => job.pocId))];
const experiences = [...new Set(jobs.map(job => job.experienceRequired))];

  const [filteredJobs, setFilteredJobs] = useState(jobs); // To store filtered jobs
  const [searchCriteria, setSearchCriteria] = useState({
    jobTitle: '',
    primarySkill: '',
    secondarySkill: '',
    jobLocation: '',
    pocId: '',
    experienceRequired: '',
  });

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [currentJob, setCurrentJob] = useState(null);
  const [formData, setFormData] = useState({
    jobid:'',
    jobTitle: '',
    jobDescription:'',
    primarySkill: '',
    secondarySkill:'',
    jobLocation: '',
    jobLink: '',
    jobId: '',
    pocId: '',
    status: '',
    experienceRequired: '',
  });
 
  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    const updatedCriteria = {
      ...searchCriteria,
      [name]: value,
    };
    setSearchCriteria(updatedCriteria);
  
    // Auto search on change
    const filtered = jobs.filter((job) => {
      return (
        job.jobTitle.toLowerCase().includes(updatedCriteria.jobTitle.toLowerCase()) &&
        job.primarySkills.toLowerCase().includes(updatedCriteria.primarySkills.toLowerCase()) &&
        job.jobLocation.toLowerCase().includes(updatedCriteria.jobLocation.toLowerCase()) &&
        job.jobDescription.toLowerCase().includes(updatedCriteria.jobDescription.toLowerCase()) &&
        job.secondarySkill.toLowerCase().includes(updatedCriteria.secondarySkill.toLowerCase()) &&
        job.experienceRequired.toLowerCase().includes(updatedCriteria.experienceRequired.toLowerCase()) &&
        job.pocId.toLowerCase().includes(updatedCriteria.pocId?.toLowerCase() || '')
      );
    });
    setFilteredJobs(filtered);
  };
  

  const handleSelectChange = (value, field) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [field]: value,
    }));
  };
  

  

  const handleSearch = () => {
    const filtered = jobs.filter((job) => {
      return (
        
        job.jobTitle.toLowerCase().includes(searchCriteria.jobTitle.toLowerCase()) &&
        job.primarySkill.toLowerCase().includes(searchCriteria.primarySkill.toLowerCase()) &&
        job.jobLocation.toLowerCase().includes(searchCriteria.jobLocation.toLowerCase()) &&
        job.jobDescription.toLowerCase().includes(searchCriteria.jobDescription.toLowerCase()) &&
        job.secondarySkill.toLowerCase().includes(searchCriteria.secondarySkill.toLowerCase()) &&
        job.experienceRequired.toLowerCase().includes(searchCriteria.experienceRequired.toLowerCase()) &&
        job.pocId.toLowerCase().includes(searchCriteria.pocId?.toLowerCase() || '')
      );
    });
    setFilteredJobs(filtered);
  };
  

  const handleDelete = (job) => {
    setCurrentJob(job);
    setDeleteModalVisible(true);
  };

  const handleConfirmDelete = async () => {
    if (!currentJob?.id) return;
  
    try {
      await axios.delete(`http://localhost:8080/api/user/jobs/${currentJob.id}`);
      
      setJobs((prevJobs) => prevJobs.filter((job) => job.id !== currentJob.id));
      setFilteredJobs((prevJobs) => prevJobs.filter((job) => job.id !== currentJob.id));
      setDeleteModalVisible(false);
      toast.success("Job deleted successfully");
      // message.success('Job deleted successfully');
    } catch (error) {
   
message.error('Failed to delete job');
     
    }
  };
  

  const handleCancelDelete = () => {
    setDeleteModalVisible(false);
  };

  const handleEdit = (job) => {
    setCurrentJob(job);
    setFormData({
      jobid:job.id,
      jobTitle: job.jobTitle,
      primarySkill: job.primarySkill,
      secondarySkill:job.secondarySkill,
      jobLocation: job.jobLocation,
      jobLink: job.jobLink,
      jobId: job.jobId,
      pocId: job.pocId,
      status: job.status,
      experienceRequired: job.experienceRequired,
      jobDescription:job.jobDescription,
    });
    setIsModalVisible(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleUpdate = async () => {
    try {
      const jobid=formData.jobid;
      const updatedData = {
        
        jobTitle: formData.jobTitle,
        primarySkill: formData.primarySkill,
        secondarySkill:formData.secondarySkill,
        jobLocation: formData.jobLocation,
        jobLink: formData.jobLink,
        jobId: formData.jobId,
        pocId: formData.pocId,
        status: formData.status,
        experienceRequired: formData.experienceRequired,
        jobDescription:formData.jobDescription,
      };
  
      const response = await axios.put(`http://localhost:8080/api/user/jobs/edit/${jobid}`, updatedData);
      console.log("Response after update: ", response.data);
      if (response.status === 200) {
        message.success("Update successful!");
        toast.success("Update successful!");
      setTimeout(() => {
          setIsModalVisible(false);
      }, 500); // wait half second so user can see success
      } else {
        message.error("Failed to update.");
        toast.error("Failed to update.");
      }
    } catch (error) {
      console.error("Update error:", error);
      toast.error("Something went wrong during update.");
      message.error("Something went wrong during update.");
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setCurrentJob(null);
  };
  const handleDropdownChange = (name, value) => {
    const updatedCriteria = {
      ...searchCriteria,
      [name]: value || '', // if cleared, set to empty string
    };
    setSearchCriteria(updatedCriteria);
  
    const filtered = jobs.filter((job) => {
      return (
        (updatedCriteria.jobTitle ? job.jobTitle === updatedCriteria.jobTitle : true) &&
        (updatedCriteria.primarySkill ? job.primarySkill === updatedCriteria.primarySkill : true) &&
        (updatedCriteria.secondarySkill ? job.secondarySkill === updatedCriteria.secondarySkill : true) &&
        (updatedCriteria.jobLocation ? job.jobLocation === updatedCriteria.jobLocation : true) &&
        (updatedCriteria.jobDescription ? job.jobDescription === updatedCriteria.jobDescription : true) &&
        (updatedCriteria.pocId ? job.email === updatedCriteria.pocId : true) &&
        (updatedCriteria.status ? job.status === updatedCriteria.status : true) &&
        (updatedCriteria.experienceRequired ? job.experience === updatedCriteria.experienceRequired : true)
      );
    });
  
    setFilteredJobs(filtered);
  }; 
  

  return (
    
    <div className="container mx-auto mt-10 p-5  ml-0 min-w-full" >
      <div className="bg-gray-700 text-white px-4 py-3 rounded-t-md" style={{ backgroundColor: '#1f415b' }}>
        <h2 className="text-lg font-semibold" >Job Search</h2>
      </div>
      <br></br>

      {/* Job List */}
      <table className="min-w-full bg-white border border-gray-300">
      <thead>
  <tr className="bg-blue-600">
  <style>
        {`
          .custom-select .ant-select-selection-placeholder {
            color: white !important;
          }
        `}
      </style>
    <th className="px-4 py-2 text-left bg-white font-bold"style={{ backgroundColor: '#1f415b' }}>
    
      <Select
      placeholder="Job Title"
        value={searchCriteria.jobTitle || undefined}
        onChange={(value) => handleDropdownChange('jobTitle', value)}
        allowClear
        className="w-full border-none shadow-none custom-select"
        size="small"
        bordered={false}
        dropdownStyle={{ zIndex: 9999 }}
        
      >
        {jobTitles.map((title) => (
          <Select.Option key={title} value={title}>
            {title}
          </Select.Option>
        ))}
      </Select>
    </th>
    <th className="px-4 py-2 text-left bg-white font-bold" style={{ backgroundColor: '#1f415b' }}>
      <Select
        placeholder="Skill"
        value={searchCriteria.primarySkill || undefined}
        onChange={(value) => handleDropdownChange('primarySkill', value)}
        allowClear
        className="w-full border-none shadow-none custom-select"
        size="small"
        bordered={false}
        dropdownStyle={{ zIndex: 9999 }}
      >
        {skills.map((primarySkills) => (
          <Select.Option key={primarySkills} value={primarySkills}>
            {primarySkills}
          </Select.Option>
        ))}
      </Select>
    </th>
    <th className="px-4 py-2 text-left bg-white font-bold" style={{ backgroundColor: '#1f415b' }}>
      <Select
        placeholder="Location"
        value={searchCriteria.jobLocation || undefined}
        onChange={(value) => handleDropdownChange('jobLocation', value)}
        allowClear
        className="w-full border-none shadow-none custom-select"
        size="small"
        bordered={false}
        dropdownStyle={{ zIndex: 9999 }}
      >
        {locations.map((location) => (
          <Select.Option key={location} value={location}>
            {location}
          </Select.Option>
        ))}
      </Select>
    </th>
    <th className="px-4 py-2 text-left bg-white font-bold" style={{ backgroundColor: '#1f415b' }}>
      <Select
        placeholder="POC Email"
        value={searchCriteria.email || undefined}
        onChange={(value) => handleDropdownChange('email', value)}
        allowClear
        className="w-full border-none shadow-none custom-select"
        size="small"
        bordered={false}
        dropdownStyle={{ zIndex: 9999 }}
      >
        {emails.map((email) => (
          <Select.Option key={email} value={email}>
            {email}
          </Select.Option>
        ))}
      </Select>
    </th>
    
    <th className="px-4 py-2 text-left bg-white font-bold" style={{ backgroundColor: '#1f415b' }}>
      <Select
        placeholder="Experience"
        value={searchCriteria.experienceRequired  || undefined}
        onChange={(value) => handleDropdownChange('experience', value)}
        allowClear
        className="w-full border-none shadow-none custom-select" 
        size="small"
        bordered={false}
        dropdownStyle={{ zIndex: 9999 }}
      >
        {experiences.map((exp) => (
          <Select.Option key={exp} value={exp}>
            {exp}
          </Select.Option>
        ))}
      </Select>
    </th>
 
    <th className="px-4 py-2 text-white font-bold" style={{ backgroundColor: '#1f415b' }}>
      Job Link
    </th>
    <th className="px-4 py-2 text-white font-bold" style={{ backgroundColor: '#1f415b' }}>Actions</th>
  </tr>
</thead>

        <tbody>
          {filteredJobs.length === 0 ? (
            <tr>
              <td colSpan="7" className="text-center px-4 py-2 text-gray-500">
                No jobs found.
              </td>
            </tr>
          ) : (
            filteredJobs.map((job) => (
              <tr key={job.id} className="hover:bg-gray-50">
                <td className="border px-4 py-2 text-sm font-medium text-gray-800">{job.jobTitle}</td>
                <td className="border px-4 py-2 text-sm font-medium text-gray-800">{job.primarySkill}</td>
                <td className="border px-4 py-2 text-sm font-medium text-gray-800">{job.jobLocation}</td>

                <td className="border px-4 py-2 text-sm font-medium text-gray-800">{job.pocId}</td>
                <td className="border px-4 py-2 text-sm font-medium text-gray-800">{job.experienceRequired}</td>
                <td className="border px-4 py-2 text-sm font-medium text-gray-800"><a href={job.jobLink}> Click Here</a></td>
                <td className="border px-4 py-2 text-sm font-medium text-gray-800 text-center">
                  <div className="flex justify-center space-x-2">
                  <button
                      onClick={() => handleEdit(job)}
                      className="p-2 text-green-500 transition hover:text-green-700"
                    >
                      <EditOutlined className="text-lg" />
                    </button>
                    <button
                      onClick={() => handleDelete(job)}
                      className="p-2 text-red-500 transition hover:text-red-700"
                    >
                      <DeleteOutlined className="text-lg" />
                    </button>
                    
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {/* Edit Modal */}
      <Modal
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        className="modal-custom"
      >
        <div className="bg-white shadow-lg rounded-lg p-6">
          <div
            className="text-white text-lg font-semibold p-4 rounded-t-lg"
            style={{ backgroundColor: '#1f415b' }}
          >
            Job Edit
          </div>

          <div className="grid grid-cols-2 gap-4 p-4">
            <div>
              <label className="block text-gray-700">Job Title</label>
              <Input name="jobTitle" value={formData.jobTitle} onChange={handleChange} />
            </div>
            <div>
              <label className="block text-gray-700">Job Description</label>
              <Input name="jobDescription" value={formData.jobDescription} onChange={handleChange} />
            </div>
            <div>
              <label className="block text-gray-700">Primary Skills</label>
              <Input name="primarySkill" value={formData.primarySkill} onChange={handleChange} />
            </div>
            <div>
              <label className="block text-gray-700">Secondary Skills</label>
              <Input name="secondarySkill" value={formData.secondarySkill} onChange={handleChange} />
            </div>
            <div>
              <label className="block text-gray-700">Job Link</label>
              <Input name="jobLink" value={formData.jobLink} onChange={handleChange} />
            </div>
            <div>
              <label className="block text-gray-700">Job ID</label>
              <Input name="jobId" value={formData.jobId} onChange={handleChange} />
            </div>
            <div>
              <label className="block text-gray-700">Job Location</label>
              <Input name="jobLocation" value={formData.jobLocation} onChange={handleChange} />
            </div>
            <div>
              <label className="block text-gray-700">POC Id</label>
              <Input name="pocId" value={formData.pocId} onChange={handleChange} />
            </div>
            <div>
  <label className="block text-gray-700">Status</label>
  <Select
    value={formData.status || 'Active'}
    onChange={(value) => handleSelectChange(value, 'status')}
    style={{ width: '100%' }}
    options={[
      { value: 'Active', label: 'Active' },
      { value: 'On Hold', label: 'On Hold' },
      { value: 'Closed', label: 'Closed' },
    ]}
  />
</div>

          
            <div>
              <label className="block text-gray-700">Experience Required</label>
              <Input name="experienceRequired" value={formData.experienceRequired} onChange={handleChange} />
            </div>
          </div>

          <div className="flex justify-center mt-4">
            <Button type="primary" onClick={handleUpdate}>
              Update
            </Button>
          </div>
        </div>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal
        visible={deleteModalVisible}
        onCancel={handleCancelDelete}
        footer={null}
        className="modal-custom"
      >
        <div className="p-6 text-center">
          <h3 className="font-semibold text-lg">Are you sure you want to delete this job?</h3>
          <div className="flex justify-center mt-4">
            <Button type="primary" danger onClick={handleConfirmDelete}>
              Yes
            </Button>
            <Button type="default" onClick={handleCancelDelete} className="ml-4">
              No
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default JobSearch;
